export const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
export const LOGIN_PRODUCT_ID = process.env.REACT_APP_LOGIN_PRODUCT_ID;
export const LOGIN_TENANT_ID = process.env.REACT_APP_LOGIN_TENANT_ID;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const ISD_CODE = process.env.REACT_APP_ISD_CODE;
export const REQUEST_PRODUCT_ID = process.env.REACT_APP_REQUEST_PRODUCT_ID;
export const STUDENT_DASHBOARD_URL =
  process.env.REACT_APP_STUDENT_DASHBOARD_URL;

export const CS_ROLE_IDS = [
  Number(process.env.REACT_APP_CS_ROLE_ID),
  Number(process.env.REACT_APP_CS_SUPER_ADMIN_ROLE_ID),
];

export const SALES_ROLE_IDS = [
  Number(process.env.REACT_APP_VALID_SALES_ROLE_ID),
  Number(process.env.REACT_APP_INTERNAL_RENEWAL_SALES),
  Number(process.env.REACT_APP_INTERNAL_TELE_SALES),
  Number(process.env.REACT_APP_SCA_SALES_AGENT_ROLE_ID),
  Number(process.env.REACT_APP_EXTERNAL_TELE_SALES),
  Number(process.env.REACT_APP_CS_SALES_ROLE_ID),
];
export const VALID_SALES_ROLE_IDS = {
  [Number(process.env.REACT_APP_VALID_SALES_ROLE_ID)]: "salesportal",
  [Number(process.env.REACT_APP_INTERNAL_RENEWAL_SALES)]:
    "internal_renewal_sales",
  [Number(process.env.REACT_APP_INTERNAL_TELE_SALES)]: "internal_tele_sales",
  [Number(process.env.REACT_APP_CS_SALES_ROLE_ID)]: "cs_sales",
};
export const ROLES_FOR_SEARCHING_AGENT = [
  Number(process.env.REACT_APP_VALID_SALES_ROLE_ID),
  Number(process.env.REACT_APP_INTERNAL_RENEWAL_SALES),
  Number(process.env.REACT_APP_INTERNAL_TELE_SALES),
  Number(process.env.REACT_APP_SCA_SALES_AGENT_ROLE_ID),
  Number(process.env.REACT_APP_CS_SALES_ROLE_ID),
];
export const CALL_API_ENDPOINT = process.env.REACT_APP_CALL_API_ENDPOINT;
export const CALL_API_SECRET_TOKEN =
  process.env.REACT_APP_CALL_API_SECRET_TOKEN;
export const PRODUCT_NAME = process.env.REACT_APP_PRODUCT_NAME;
export const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const INDIAN_CURRENCY_ID = 1;
export const ORDER_STATUSES = {
  ACCEPTED: 1,
  FULFILLED: 2,
  DISCARDED: 3,
  CANCELLATION_REQUESTED: 4,
  CANCELLED: 5,
  SUSPENDED: 6,
};

export const PAYMENT_STATUSES = {
  CREATED: 1,
  VERIFIED: 2,
  ACTIVATED_BY_PROVIDER: 3,
  REJECTED_BY_PROVIDER: 4,
  CANCELLED_BY_CUSTOMER: 5,
  REJECTED_BY_INFINITY_LEARN: 6,
  APPROVED_BY_PROVIDER: 7,
  DISBURSED: 8,
};

export const REFUND_STATUSES = {
  CREATED: 1,
  SUCCEEDED: 2,
};

export const ONGOING_AND_SUCCESSFUL_PAYMENT_STATUSES = [
  PAYMENT_STATUSES.CREATED,
  PAYMENT_STATUSES.VERIFIED,
  PAYMENT_STATUSES.ACTIVATED_BY_PROVIDER,
  PAYMENT_STATUSES.APPROVED_BY_PROVIDER,
  PAYMENT_STATUSES.DISBURSED,
];

export const SUCCESSFUL_REFUND_STATUSES = [REFUND_STATUSES.SUCCEEDED];

export const ONGOING_PAYMENT_STATUS = [PAYMENT_STATUSES.CREATED];

export const PENDING_ORDER_STATUS = [
  ORDER_STATUSES.ACCEPTED,
  ORDER_STATUSES.CANCELLATION_REQUESTED,
  ORDER_STATUSES.SUSPENDED,
];

export const SUCCESSFUL_PAYMENT_STATUSES = [
  PAYMENT_STATUSES.VERIFIED,
  PAYMENT_STATUSES.ACTIVATED_BY_PROVIDER,
  PAYMENT_STATUSES.APPROVED_BY_PROVIDER,
  PAYMENT_STATUSES.DISBURSED,
];

export const PACKAGE_DETAILS_COLUMN = [
  { label: "Package Name", field: "name" },
  { label: "Package Price", field: "price" },
  { label: "Discount", field: "discount" },
  { label: "Duration (days)", field: "duration" },
  { label: "Grade", field: "grade" },
];
export const PAYMENT_DETAILS_COLUMN = [
  { label: "Amount", field: "amount" },
  { label: "Status", field: "status" },
  { label: "Payment Date", field: "paymentDate" },
  { label: "Payment Method", field: "paymentMethod" },
  { label: "Receipt", field: "receipt" },
];
export const PAYMENTS_ATTEMPTS_COLUMN = [
  { label: "Date", field: "date" },
  { label: "Method", field: "method" },
  { label: "Status", field: "status" },
  { label: "Reason", field: "reason" },
  { label: "Description", field: "description" },
];
export const REFUND_DETAILS_COLUMN = [
  { label: "Refund Amount", field: "amount" },
  { label: "Status", field: "status" },
  { label: "Time Stamp", field: "refundDate" },
  { label: "Refund Reason", field: "refundReason" },
];
export const PART_PAYMENT_DETAILS_COLUMN = [
  { label: "Installment No", field: "installmentNo" },
  { label: "Amount", field: "amount" },
  { label: "Amount Paid", field: "amountPaid" },
  { label: "Status", field: "status" },
  { label: "Due Date", field: "dueDate" },
];

export const ONGOING_PAYMENT_STATUSES = [
  PAYMENT_STATUSES.CREATED,
  PAYMENT_STATUSES.VERIFIED,
  PAYMENT_STATUSES.ACTIVATED_BY_PROVIDER,
];

export const X_TENANT = "infinitylearn";
export const HARDWARE_PRODUCT_TYPE_ID = 7;
export const DEFAULT_COUNTRY_NAME = "India";

export const INR_SYMBOL = "₹ ";

export const ONE_RUPEE = 1;

export const LOAN_STATUSES = {
  CREATED: 1,
  DISBURSED: 2,
  CANCELLED: 3,
};

export const BUSINESS_VERTICALS = {
  LEARN: 1,
  KH: 2,
};

export const NO_OF_PACKAGE_SUBSCRIPTION_IN_KH = 1;

export const PAYMENT_METHODS = [
  {
    id: 1,
    value: "1",
    label: "Full Payment",
  },
  {
    id: 2,
    value: "2",
    label: "Part Payment",
  },
];

export const FULL_PAYMENT = 1;
export const PART_PAYMENT = 2;

export const SEARCH_USER_TYPE = {
  PHONE_NUMBER: "phoneNumber",
  UAM_ID: "uamId",
};

export const STUDENT_ID_TYPE = "UAM";

export const FULL_PAYMENT_FLOW_TYPE_ID = 1;

export const PART_PAYMENT_FLOW_TYPE_ID = 2;

export const PLUTUS_PAYMENT_LINK_SOURCE = 1;

export const KH_VERTICAL_ID = 2;

export const LEARN_VERTICAL_ID = 1;

export const MAX_ALLOWED_USER_OBJECT_LENGTH = 1;

export const PART_PAYMENT_FULLY_PAID_STATUS_ID = 3;

export const PART_PAYMENT_PARTIALLY_PAID_STATUS_ID = 2;

export const PART_PAYMENT_STATUSES = {
  CREATED: 1,
  PARTIALLY_PAID: 2,
  FULLY_PAID: 3,
};

export const KH_PRODUCT_ID = 900;
export const KH_TENANT_ID = 7;

export const LEARN_PRODUCT_ID = 300;
export const LEARN_TENANT_ID = 1;

export const LOAN_PAYMENT_METHOD = 13;

export const BUSINESS_VERTICAL = {
  1: "Learn",
  2: "SCA",
};

export const DISCOUNT_TYPE = {
  DYNAMIC: "DYNAMIC",
  COUPON_CODE: "COUPON_CODE",
};
export const BUSINESS_VERTICALS_IDS = [
  {
    id: 1,
    value: "1",
    label: "Learn",
  },
  {
    id: 2,
    value: "2",
    label: "SCA",
  },
];
export const PRODUCT_ID_TO_BUSINESS_VERTICAL = {
  300: 1,
  900: 2,
};

export const VERTICAL_ID_TO_PRODUCT_ID = {
  1: "300",
  2: "900",
};

export const DISCOUNT_MODES = [
  { value: "dynamic", label: "Discount amount or %" },
  { value: "code", label: "Discount code" },
];

export const MIN_COUPON_CODE_LENGTH = 3;

export const BOOK_COMPONENT_CATEGORY_ID = 2;
export const PYP_BOOK_COMPONENT_CATEGORY_ID = 19;

export const BOOK_COMPONENT_CATEGORY_IDS = [
  BOOK_COMPONENT_CATEGORY_ID,
  PYP_BOOK_COMPONENT_CATEGORY_ID,
];

export const CHEQUE_PAYMENT_METHOD = 16;
export const CASH_PAYMENT_METHOD = 6;
export const BANK_TRANSFER_PAYMENT_METHOD = 15;
export const MANDATE_PAYMENT_METHOD = 18;
export const ADJUSTMENT_AGAINST_REFUNDS = 14;

export const LEARN_PAYMENT_MODE_OPTIONS = [
  {
    id: 1,
    value: "ONLINE",
    label: "Online",
  },
  {
    id: 2,
    value: "BANK_TRANSFER",
    label: "Bank Transfer",
  },
  {
    id: 3,
    value: "CASH",
    label: "Cash",
  },
  {
    id: 4,
    value: "CHEQUE",
    label: "Cheque",
  },
];

export const SCA_PAYMENT_MODE_OPTIONS = [
  {
    id: 1,
    value: "ONLINE",
    label: "Online",
  },
  {
    id: 2,
    value: "CASH",
    label: "Cash",
  },
  {
    id: 3,
    value: "CHEQUE",
    label: "Cheque",
  },
];

export const PAYMENT_MODE = {
  CASH: "CASH",
  CHEQUE: "CHEQUE",
  ONLINE: "ONLINE",
  BANK_TRANSFER: "BANK_TRANSFER",
};

export const CHEQUE_STATUS = {
  CREATED: 1,
  VERIFIED: 2,
  DISBURSED: 3,
  CANCELLED: 4,
  FAILED: 5,
};

export const BANK_TRANSFER_STATUS_IDS = {
  CREATED: 1,
  DISBURSED: 2,
  CANCELLED: 3,
  FAILED: 4,
};
export const PAYMENT_MODE_LABEL = {
  CASH: "cash",
  CHEQUE: "cheque",
  BANK_TRANSFER: "bank transfer",
};
export const MAX_BANK_TRANSFER_REFERENCE_ID_LENGTH = 100;

export const SINGLE_MATCH = 1;

export const VERTICAL_NAME = {
  [KH_VERTICAL_ID]: "SCA",
  [LEARN_VERTICAL_ID]: "Learn",
};
export const INVOICE_DETAILS_COLUMN = [
  { label: "Billing Entity", field: "billingEntity" },
  { label: "Invoice Number", field: "invoiceNumber" },
  { label: "Invoice Date", field: "invoiceDate" },
  { label: "Amount", field: "amount" },
  { label: "Download", field: "download" },
];

export const COUNTRIES_FOR_LEARN = [
  {
    id: 1,
    value: "1",
    label: "India",
  },
];
export const COUNTRIES_FOR_SCA = [
  {
    id: 1,
    value: "1",
    label: "India",
  },
];
export const COUNTRY_ID_TO_DIAL = {
  1: "+91",
  2: "+966",
  3: "+971",
  4: "+968",
  5: "+973",
  6: "+974",
  7: "+965",
};

export const MIDDLE_EAST_COUNTRIES = [2, 3, 4, 5, 6, 7];

export const IN_HOUSEPART_PAYMENT = {
  id: 1,
  value: 1,
  label: "In-house Part Payment",
  name: "IN_HOUSE_PART_PAYMENT",
};
export const JODO_FLEX = {
  id: 2,
  value: 2,
  label: "JODO Flex",
  name: "JODO_FLEX",
};
export const SCA_PROVIDERS = [JODO_FLEX];
export const LEARN_PROVIDERS = [];
export const PAYMENT_PLAN_OPTIONS = [
  {
    id: 1,
    value: 1,
    label: "Full Payment",
  },
  {
    id: 2,
    value: 2,
    label: "Part Payment",
  },
  {
    id: 3,
    value: 3,
    label: "Loan",
  },
];
export const PAYMENT_PLANS = {
  FULL_PAYMENT: 1,
  PART_PAYMENT: 2,
  LOAN: 3,
};

export const FIRST_INSTALLMENT_NUMBER = 1;

export const CHEQUE_NUMBER_LENGTH = 6;

export const EDIT_PAYMENT_FLOW_TYPE_COLUMNS = [
  { label: "Provider", field: "provider" },
  { label: "Payment Flow Status", field: "paymentFlowStatus" },
  { label: "Number of parts", field: "numberOfParts" },
  { label: "Time Stamp", field: "timeStamp" },
  { label: "Actions", field: "actions" },
];

export const PART_PAYMENT_PROVIDER_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
  CREATED: 3,
  APPROVED: 4,
  CANCELLED: 5,
  COMPLETED: 6,
  EXPIRED: 7,
  SETUP: 8,
};

export const IS_JODO_DISABLED = false;

export const INDIAN_ISD_CODE = "+91";

export const RAZORPAY_PAYMENT_GATEWAY_PROVIDER = {
  id: 2,
  label: "Razorpay",
  value: 2,
  name: "Razorpay",
};

export const PAYU_PAYMENT_GATEWAY_PROVIDER = {
  id: 4,
  label: "PayU",
  value: 4,
  name: "PayU",
};

export const LEARN_PAYMENT_GATEWAY_PROVIDERS = [
  RAZORPAY_PAYMENT_GATEWAY_PROVIDER,
  PAYU_PAYMENT_GATEWAY_PROVIDER,
];

export const SCA_PAYMENT_GATEWAY_PROVIDERS = [
  RAZORPAY_PAYMENT_GATEWAY_PROVIDER,
];

export const PAYMENT_GATEWAY_PROVIDERS_MAP = {
  2: "Razorpay",
  4: "PayU",
};

export const RECEIPT_DOWNLOAD_DISABLED_AFTER = new Date("2026-01-25T23:59:59");

export const ACADEMIC_YEAR_2026 = 2026;

export const COMPONENT_CATEGORIES = {
  LIVE_CLASS: "LIVECLASS",
};

export const ORDER_MODIFICATION_SUMMARY_COLUMN = [
  { label: "Description", field: "description" },
  { label: "Current Order", field: "currentOrder" },
  { label: "Proposed Order", field: "proposedOrder" },
];

export const DISCARD_ORDER_MODIFICATION_OPERATION = "DISCARD";

export const PLUTUS_SOURCE_ID = 1;

export const ZERO = 0;
export const SCA_ONE_APP_MIGRATED = true;

export const ORDER_MODIFICATION_LIMITS_FOR_SALES = {
  [LEARN_VERTICAL_ID]: 2,
  [KH_VERTICAL_ID]: 1,
};
